import React from 'react'
import Header from '../components/Header';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

function FreeConsultation() {
    useSEO({
        title: "Free Consultation | Expert Digital Marketing & Web Development Advice | Empower Web",
        description: "Schedule a free 30-minute consultation with our digital marketing and web development experts. Get personalized advice for your project.",
        canonical: "https://empowerweb.in/free-consultation",
        ogTitle: "Free Consultation | Expert Advice",
        ogDescription: "Get a free consultation from our digital marketing and web development experts.",
        keywords: "free consultation, expert consultation, digital marketing advice, web development consultation, free advice"
    });
    return (
        <div>
            <Header />
            <Navbar />
            <section style={{padding: '60px 40px', minHeight: '70vh'}}>
                <div style={{maxWidth: '800px', margin: '0 auto'}}>
                    <h1 style={{fontSize: '2.5rem', color: '#0868a0', marginBottom: '30px', textAlign: 'center'}}>Free Consultation</h1>
                    <p style={{fontSize: '1.1rem', color: '#666', lineHeight: '1.8', marginBottom: '40px', textAlign: 'center'}}>
                        Get expert advice on your digital marketing and web development needs. Schedule a free 30-minute consultation with our team.
                    </p>
                    <form style={{background: '#f5f5f5', padding: '40px', borderRadius: '8px'}}>
                        <div style={{marginBottom: '20px'}}>
                            <label style={{display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333'}}>Name</label>
                            <input type="text" placeholder="Your Name" style={{width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        <div style={{marginBottom: '20px'}}>
                            <label style={{display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333'}}>Email</label>
                            <input type="email" placeholder="Your Email" style={{width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd'}} />
                        </div>
                        <div style={{marginBottom: '20px'}}>
                            <label style={{display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333'}}>Message</label>
                            <textarea placeholder="Tell us about your project..." rows="5" style={{width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', fontFamily: 'Arial'}}></textarea>
                        </div>
                        <button style={{background: '#0868a0', color: 'white', padding: '12px 32px', borderRadius: '4px', border: 'none', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer', width: '100%'}}>
                            Schedule Consultation
                        </button>
                    </form>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default FreeConsultation;
